// extracted by mini-css-extract-plugin
export var dateLabel = "_4c-0";
export var dateLabelError = "_4c-1";
export var fullWidth = "_4c-2";
export var smaller = "_4c-3";